import React, {useMemo} from 'react';
import dayjs from 'dayjs';
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import { getRegionCode } from '../../utils';

dayjs.extend(isSameOrAfter);

const tncTypes = {
  A: [
    {
      text: "本公司已将課程具体内容、方法、课程费用、注意问题等事项向顾客作出了详细说明,顾客特此确认已知悉并完全理解该等说明,并自愿参加課程计划,接受本合约的条款。",
    },
    {
      text: "顾客守则及规例张贴於本公司之店铺内, 顾客守则及规例之小册子亦放置於本公司店铺内供顾客免费取阅。顾客在使用本公司该等服务时同意遵守本公司顾客守则及规例，不得以不知情为由，不遵守或违反本公司顾客守则及规例。",
    },
    {
      text: "本公司不曾强迫顾客购买该等服务,而顾客是行使其自由意志自行选择购买所需之该等服务。本合約期限为自顾客缴付定金之日起6个月。",
    },
    {
      text: "因有关课程之效果因人而异,多取决于非本公司所能预见及控制之因素,故本公司不保证顾客所选购課程 / 服務取得顾客期望效果。为取得理想之效果,顾客须遵从本公司工作人员之营养指导及其它相关指引,并按照本公司建议履行所有课程之环节,不应中断。",
    },
    {
      text: "顾客与本公司工作人员的任何协议须在课程协议书上书面说明,并须附有本公司工作人员之签署方可作实并以此为准。",
    },
    {
      text: "顾客支付全部课程费用后,本公司将为顾客提供课程服务。顾客自交付定金之日起30日内须缴付全部课程费用。顾客缴付的定金具有相应的法律效力，应适用于定金罚则。",
    },
    {
      text: "顾客支付课程费后，不得无故要求退还，但可要求更换本公司其他等值服务课程；顾客确因特殊情况需要退还课程费用的，因本公司无过错，对于退款的课程本公司将不再给予顾客课程费用优惠和折扣，本公司将在扣除顾客已经实际消费的课程所对应的课程费用（顾客已经消费课程费=顾客享受折扣或优惠前的课程单价×顾客实际消费课程数量）后，将剩余课程费用退回顾客。退款同时，顾客应当退回签署的课程协议原件及本公司开具的发票原件。",
      // className: 'bold'
    },
    {
      text: "顾客签约时应将服务费以现金成转帐方式支付给甲方(即公司)，不得以支付宝、微信或银行转帐方式支付给甲方(公司)员工个人。否则，顾客自行承担不利后果。",
      // className: 'bold'
    },
    {
      text: "本协议及课程属顾客个人所有,仅适用于顾客本人并限顾客本人享用,不得授权、转借、赠予、出售或转让他人。",
    },
    {
      text: "本公司不提供医疗服务,有关课程计划所提供的体型护理只属体型护理服务而非医疗服务。本公司可根据顾客需要及个别情况,推荐额外的护理服务、课程或营养计划,但最终选择权由顾客根据其身体实际状况自行审慎决定。",
    },
    {
      text: "顾客须在签署本合约前将个人身体健康状况如实告知本公司,包括任何已知悉之病历、过敏反应及皮肤状况,否则，顾客须对课程服务过程中引起任何之不适、不良反应、病症或损伤等自己负责,且不得向本公司追究任何责任及任何赔偿。",
    },
    {
      text: "顾客单方解除或终止本合约的（包括退款），应向本公司支付相当于购买课程总金额10%的违约金。如因本协议产生的任何争议,任何一方均可向本公司所在地之人民法院提起诉讼。",
    },
    {
      text: "本公司可向顾客作出的任何通知、要求和其它通信往来将根据顾客数据所载的电话或地址发出,如有任何变更，顾客应立即通知本公司该等电话或地址。",
    },
    {
      text: "切勿把贵重物品存放在本公司之储物柜内,顾客如遗失任何贵重物品或私人财物,本公司恕不负责。",
    },
  ],
  B: [
    {
      text: "本公司已将課程具体内容、方法、课程费用、注意问题等事项向顾客作出了详细说明,顾客特此确认已知悉并完全理解该等说明,并自愿参加課程计划,接受本合约的条款。",
    },
    {
      text: "顾客守则及规例张贴於本公司之店铺内,顾客守则及规例之小册子亦放置於本公司店铺内供顾客免费取阅。顾客在使用本公司该等服务时同意遵守本公司顾客守则及规例，不得以不知情为由，不遵守或违反本公司顾客守则及规例。",
    },
    {
      text: "本公司不曾强迫顾客购买该等服务,而顾客是行使其自由意志自行选择购买所需之该等服务。本合約期限为自顾客缴付全款之日起计6个月。",
    },
    {
      text: "因有关课程之效果因人而异,多取决于非本公司所能预见及控制之因素,故本公司不保证顾客所选购課程 / 服務取得顾客期望效果。为取得理想之效果,顾客须遵从本公司工作人员之营养指导及其它相关指引,并按照本公司建议履行所有课程之环节,不应中断。",
    },
    {
      text: "顾客与本公司工作人员的任何协议须在课程协议书上书面说明,并须附有本公司工作人员之签署方可作实并以此为准。",
    },
    {
      text: "顾客支付全部课程费用后,本公司将为顾客提供课程服务。顾客自交付定金之日起30日内须缴付全部课程费用，顾客缴付的定金具有相应的法律效力，应适用于定金罚则。",
    },
    {
      text: "顾客签约时应将服务费以现金成转帐方式支付给甲方(即公司)，不得以支付宝、微信或银行转帐方式支付给甲方(公司)员工个人。否则，顾客自行承担不利后果。",
      // className: 'bold'
    },
    {
      text: "本公司不提供医疗服务,有关课程计划所提供的体型护理只属体型护理服务而非医疗服务。本公司可根据顾客需要及个别情况,推荐额外的护理服务、课程或营养计划,但最终选择权由顾客根据其身体实际状况自行审慎决定。",
    },
    {
      text: "顾客须在签署本合约时将个人身体状况如实告知本公司，包括任何已知悉之病历、过敏反应及皮肤状况，否则，顾客须对课程服务过程中引起的任何不适、不良反应、病症或损伤等自行负责，且不得因此向本公司追究任何责任及任何赔偿。",
    },
    {
      text: "顾客单方解除或终止本合约的（包括退款），应向本公司支付相当于购买课程总金额10%的违约金，如该等客户按优惠价支付课程费用的，在解约（退款）时不再享受优惠价，其已享受的服务应按原价计费。退款同时，顾客应当退回签署的课程协议原件及本公司开具的发票原件。如因本合约产生的任何争议,任何一方均可向本公司所在地之人民法院提起诉讼。",
    },
    {
      text: "本公司可向顾客作出的任何通知、要求和其它通信往来将根据顾客数据所载的电话或地址发出,如有任何变更，顾客应立即通知本公司该等电话或地址。",
    },
  ],
};

const regionTNCTypes = {
  SZ: 'A',
  BJ: 'A',
  GZ: 'B',
  SH: 'B'
};

const tnc2025 = [
  {
    text: "本公司已将课程（该等服务）具体内容、方法、课程费用、退款原则、注意问题等事项向顾客作出了详细说明,顾客特此确认已知悉并完全理解该等说明,并自愿参加課程计划,接受本合约（即本协议）的条款。",
  },
  {
    text: "本公司没有强迫顾客购买该等服务,顾客是自发自愿购买该等服务。本合約期限为自顾客缴付定金之日起6个月。",
  },
  {
    text: "因有关课程之效果因人而异,多取决于非本公司所能预见及控制之因素,故本公司不保证、不承诺顾客所选购課程 / 服務满足或取得顾客期望效果。为取得理想之效果,顾客须遵从本公司工作人员之课程指导及其它相关指引,并按照本公司建议履行所有课程之环节,不应中断。",
  },
  {
    text: "顾客与本公司工作人员的任何协议须在本课程协议书上书面说明,并须附有本公司之蓋印方可作实并以此为准。",
  },
  {
    text: "顾客支付全部课程费用后,本公司将为顾客提供课程服务。顾客自交付定金之日起30日内须缴付全部课程费用。顾客缴付的定金适用于民法典的定金罚则。",
  },
  {
    text: "顾客签约时应将服务费以现金或转帐方式支付给本公司，不得以支付宝、微信或银行转账等方式支付给本公司员工个人。否则，顾客自行承担不利后果。 ",
  },
  {
    text: "本课程协议及相关课程仅限于顾客本人使用,不得授权、转借、赠予、出售或转让他人使用。",
  },
  {
    text: "本公司不提供医疗美容服务,有关课程计划所提供的体型护理只属体型护理服务而非医疗美容服务。本公司可根据顾客需要及个别情况,推荐额外的护理服务、课程或营养计划,但最终选择权由顾客根据其身体实际状况自行审慎决定。",
  },
  {
    text: "顾客须在签署本合约前将个人身体健康状况如实告知本公司,包括任何已知悉之病历、过敏反应及皮肤状况,否则，顾客须自行对课程服务过程中引起任何之不适、不良反应、病症或损伤等负责,且不得向本公司追究任何责任及任何赔偿。",
  },
  {
    text: "顾客支付课程费后，不得要求退还，但可要求更换本公司其他等值服务课程；顾客确因特殊情况需要退还课程费用的，在本公司无过错、无违约的情形下，如顾客是按优惠价购买本协议课程的，在退款时课程将不按优惠价计算，其已实际消费的课程、服务应按原价计算。即退款计算公式为：退款金额=顾客支付的课程总费用-顾客已消费课程费（课程原价单价×顾客实际消费课程数量）。退款时，顾客应当退回签署的本课程协议原件及本公司开具的发票原件。",
  },
  {
    text: "顾客单方面解除或终止本课程协议的（包括退款），视为违约，应向本公司支付相当于购买课程总金额30%的违约金。如因本课程协议产生的任何争议,任何一方均可向本公司所在地人民法院提起诉讼。",
  },
  {
    text: "本公司可向顾客作出的任何通知、要求和其它通信往来将根据顾客数据所载的电话或地址发出，如有任何变更，顾客应立即通知本公司该等电话或地址。",
  },
  {
    text: "顾客切勿把贵重物品存放在本公司之储物柜内,顾客如遗失、损坏任何贵重物品或私人财物,本公司恕不负责。",
  },
];

const TNC = props => {
  const { tnc } = props;
  const { Address, Invoicedate } = tnc;

  const tncData = useMemo(() => {
    if (dayjs(Invoicedate).isSameOrAfter(dayjs("2025-01-16"), "day")) {
      return tnc2025;
    } else {
      const regionCode = getRegionCode(Address);
      return tncTypes[regionTNCTypes[regionCode]];
    }
  }, [Address, Invoicedate]);

  return tncData ? (
    <div className={"tnc page-break"}>
      <p className={"title bold underline"}>服务条款</p>
      <ol>
        {tncData.map(({ text, className }, i) => (
          <li key={i} className={className}>
            {text}
          </li>
        ))}
      </ol>
    </div>
  ) : null;
};

export default TNC;